export var VERTICAL_MARGIN = 126;
export var HORIZONTAL_PADDING = 24;
export var HIGH_ADDITIONAL_DISTANCE_TO_WINDOW_BORDER = 16;
export var LOW_ADDITIONAL_DISTANCE_TO_WINDOW_BORDER = 0;
